import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/shared/models/user.model';

@Component({
  selector: 'app-compare-user-dialog',
  templateUrl: './compare-user-dialog.component.html',
  styleUrls: ['./compare-user-dialog.component.scss']
})
export class CompareUserDialogComponent implements OnInit {

  existingUser: User;
  newUser: User;


  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<CompareUserDialogComponent>, public dialog: MatDialog) {
    this.existingUser = data.existingUser;
    this.newUser = data.newUser;
    console.log(data)
  }

  ngOnInit() {
  }

}
